var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.ceb1398d26a0aa56237e49d2ebf51130.svg#plus';
                    var viewUrl = 'svg/global.ceb1398d26a0aa56237e49d2ebf51130.svg#view-plus';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };